import { createAction, props } from '@ngrx/store';
import { ReceiptModeModel } from '@shared/data-access/models';

export const loadItem = createAction('[ReceiptMode] Load item', props<{ id: number }>());
export const loadItemSuccess = createAction('[ReceiptMode] Load item success', props<{ item: ReceiptModeModel }>());
